module.exports = __webpack_public_path__ + "img/horizontal_3_3_9016.25047f48.png";